import hdrm from '../../hdrm';
import site from '../../site';

import actionTypes from '../constants/action-types';
import globals from '../../globals';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const duplicateElement = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.DUPLICATE_ELEMENT: {
      const { elementId, globalsToUpdate, options } = action.payload;
      const { strategy } = options;

      const newHTML = hdrm.operations.duplicateElement(elementId, strategy);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default duplicateElement;
